
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/complete",
      function () {
        return require("private-next-pages/contact/complete.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/complete"])
      });
    }
  